"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _sharedInternals = require("./sharedInternals");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const ChunkExtractorManager = ({
  extractor,
  children
}) => _react.default.createElement(_sharedInternals.Context.Provider, {
  value: extractor
}, children);

var _default = ChunkExtractorManager;
exports.default = _default;